import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout.impulsodigitalx.shop/cart/45707755323553:1';
export function BeforeAfterSection() {
  const beforeItems = ['Caos en las rutinas', 'Berrinches que te superan', 'Culpa después de perder la paciencia', 'Sensación constante de estar fallando', 'Cansancio emocional diario'];
  const afterItems = ['Rutinas claras y flexibles', 'Límites sostenidos con calma', 'Niños más autónomos', 'Más seguridad como adulto', 'Un hogar más tranquilo'];
  return <section className="w-full bg-[#FDF8F3] py-16 px-4" data-id="element-20">
      <div className="max-w-4xl mx-auto" data-id="element-21">
        <h2 className="text-2xl sm:text-3xl font-bold text-[#5C4033] mb-10 text-center" data-id="element-22">
          🔄 ANTES VS DESPUÉS
        </h2>

        <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-23">
          {/* Before */}
          <div className="bg-[#FDE8E4] rounded-2xl p-6 sm:p-8 border-2 border-[#E8C4BE]" data-id="element-24">
            <h3 className="text-xl font-bold text-[#C4645A] mb-6 text-center" data-id="element-25">
              ❌ Antes
            </h3>
            <ul className="space-y-4" data-id="element-26">
              {beforeItems.map((item, index) => <li key={index} className="flex items-center gap-3" data-id="element-27">
                  <span className="flex-shrink-0 w-6 h-6 bg-[#C4645A] text-white rounded-full flex items-center justify-center" data-id="element-28">
                    <XIcon className="w-4 h-4" data-id="element-29" />
                  </span>
                  <span className="text-[#8B7355]" data-id="element-30">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* After */}
          <div className="bg-[#E8EDE5] rounded-2xl p-6 sm:p-8 border-2 border-[#B8C9B0]" data-id="element-31">
            <h3 className="text-xl font-bold text-[#6B8068] mb-6 text-center" data-id="element-32">
              ✅ Después
            </h3>
            <ul className="space-y-4" data-id="element-33">
              {afterItems.map((item, index) => <li key={index} className="flex items-center gap-3" data-id="element-34">
                  <span className="flex-shrink-0 w-6 h-6 bg-[#8B9E7E] text-white rounded-full flex items-center justify-center" data-id="element-35">
                    <CheckIcon className="w-4 h-4" data-id="element-36" />
                  </span>
                  <span className="text-[#5C4033]" data-id="element-37">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Imaginá esto */}
        <div className="bg-[#F5EDE4] rounded-2xl p-8 mb-10 text-center border border-[#E0D5C8]" data-id="element-38">
          <p className="text-lg font-semibold text-[#5C4033] mb-4" data-id="element-39">
            Imaginá esto:
          </p>
          <p className="text-[#8B7355] text-lg leading-relaxed" data-id="element-40">
            Una mañana sin gritos. Tu hijo intentando vestirse solo. Vos
            poniendo un límite con firmeza y calma. Un berrinche que no termina
            en culpa.
          </p>
          <p className="text-[#8B9E7E] font-semibold mt-4 text-lg" data-id="element-41">
            Eso cambia cuando tenés estructura.
          </p>
        </div>

        <div className="text-center" data-id="element-42">
          <a href={CHECKOUT_URL} className="inline-block bg-[#D4956A] hover:bg-[#C4845C] text-white text-lg font-bold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:scale-105" data-id="element-43">
            👉 SÍ, QUIERO ESTE CAMBIO EN MI CASA
          </a>
        </div>
      </div>
    </section>;
}